import { render } from "./Conversion.vue?vue&type=template&id=027c56a8"
import script from "./Conversion.vue?vue&type=script&lang=js"
export * from "./Conversion.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__